import React from 'react';
import Typography from '../typography/Typography';

interface specification {
  name: string;
  value: string;
  piece?: string;
}

const Specification = ({ name, value, piece }: specification) => {
  return (
    <div className="flex justify-between">
      <Typography tag="p" type="label">
        {name}
      </Typography>
      <div>
        <Typography tag="span" type="label">
          {value}
        </Typography>
        {piece && (
          <>
            &nbsp;
            <Typography tag="span" type="label">
              {piece}
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

export default Specification;
